import type { ReactNode } from "react";

import type { TourTargetId } from "@/components/Playground/tour/constants";

interface TourTargetContainerProps {
  id: TourTargetId;
  className?: string;
  children?: ReactNode;
  as?: "div" | "span";
}

const TourTargetContainer = ({
  id,
  className,
  children,
  as: Component = "div",
}: TourTargetContainerProps) => (
  <Component id={id} className={className}>
    {children}
  </Component>
);

export default TourTargetContainer;
